var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"register-confirmation"},[_c('div',{staticClass:"side-image u-bgcolor"}),_c('div',{staticClass:"register-confirmation-content"},[_c('p',{staticClass:"register-confirmation-content-message u-bfbgcolor u-bgcolor-pseudo"},[_vm._v("Check your mailbox for your confirmation link")])])])
}]

export { render, staticRenderFns }